import { Button, Container, Flex } from '@chakra-ui/react'
import { ArrowLeft } from '@components/icons'
import React from 'react'
import { useHistory } from 'react-router-dom'

interface BackButtonProps {
  to?: string
}

export const BackButton: React.FC<BackButtonProps> = ({
  to = '/settings/templates'
}) => {
  const history = useHistory()

  return (
    <Container mt="8px" style={{ maxWidth: 'none' }}>
      <Flex flex="1" justifyContent="space-between">
        <Button
          m="0px"
          leftIcon={<ArrowLeft fill="#2D54E8" />}
          variant="link"
          colorScheme="primary"
          textDecoration="none"
          _focus={{ outline: 'none' }}
          _hover={{ textDecoration: 'underline' }}
          onClick={() => {
            history.push(to)
          }}
        >
          Back
        </Button>
      </Flex>
    </Container>
  )
}

export default BackButton
